import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-special-purpose-transformers',
  templateUrl: './special-purpose-transformers.component.html',
  styleUrls: ['./special-purpose-transformers.component.css']
})
export class SpecialPurposeTransformersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  	
  }

}
